<template>
  <div>
    <a-modal :width="'100%'" :visible="visible" :maskClosable="false" :dialogStyle="{top: 0}" :bodyStyle="{padding:0}"
      :destroyOnClose="true" :footer="null" @cancel="closeEditor">
      <a-icon slot="closeIcon" type="close-circle" theme="twoTone" style="font-size: 30px;line-height: 70px;"/>
      <div slot="title">
        <a-row>
           <a-col :span="8">
            <span><j-ellipsis :value="workInfo.workName" :length="30" /></span>
           </a-col>
          <a-col :span="8">
            <a-button
              v-if="workInfo.workDocumentUrl != null"
              @click="openWorkFile(workInfo.workDocumentUrl_url)"
              >作业资料</a-button
            >
            <a-divider v-if="workInfo.workDocumentUrl != null" type="vertical"></a-divider>

            <a-button v-if="workInfo.workDesc" type="primary" @click="viewDescVisible=true">
              作业要求
            </a-button>
            <a-divider v-if="workInfo.workDesc" type="vertical"></a-divider>

            <a-button
              type="danger"
              v-if="workInfo.mineWorkStatus == 0"
              @click="resetWork(work, true)"
            >
              重做
            </a-button>
            <a-divider v-if="workInfo.mineWorkStatus == 0" type="vertical"></a-divider>

            <a-button type="primary" @click="requestSubmitProject" icon="check">提交</a-button>
          </a-col>
        </a-row>
        </div>
      <iframe :src="editorUrl" id="player" frameborder="0" width="100%" :style="{height: 'calc(100vh - 64px', minHeight:'800px'}"
        scrolling="no"></iframe>
    </a-modal>
    <!-- 作业要求弹窗 -->
    <a-modal :width="800" :visible="viewDescVisible" :footer="null" @cancel="viewDescVisible=false">
      <div slot="title">
        <h3 style="display: inline;">作业要求</h3>
        <a-divider type="vertical"></a-divider>
      </div>
      <div v-html-md="workInfo.workDesc">
      </div>
    </a-modal>
    <TeachingWorkSubmitModal ref="submitModal"/>
  </div>
    
</template>
<script>
import JEllipsis from "@/components/jeecg/JEllipsis";
import TeachingWorkSubmitModal from "@/components/work/TeachingWorkSubmitModal";

export default {
  name: 'Examine',
  components: {
    JEllipsis,
    TeachingWorkSubmitModal
  },
  data(){
    return{
      visible: false,
      viewDescVisible: false,
      workInfo: {},
      editorUrl: '',
      saved: false
    }
  },
  created(){

  },
  mounted(){
    let that = this
    //监听代码提交事件
    document.addEventListener('submit', function (e) {
      console.log(e.detail);
      that.saved = true
      
    })
    document.addEventListener('submitOJ', function (e) {
      console.log(e.detail);
      that.saved = true
    })
  },
  methods:{
    open(workInfo, reset){
      this.workInfo = workInfo
      this.editorUrl = this.getAdditionalWork(workInfo, reset)
      this.visible = true
      if(this.workInfo.workDesc){
        this.viewDescVisible = true
      }
    },
    openWorkFile(workUrl) {
      window.open(workUrl);
    },
    resetWork(){
      this.editorUrl = this.getAdditionalWork(this.workInfo, true)
    },
    //请求提交作品
    requestSubmitProject(){
      if(this.editorUrl){
        document.getElementById("player").contentWindow.handleSumbit(false)
      }else{
        this.resetWork() //弹出作业提交弹窗
      }
    },
    getAdditionalWork(item, reset) {
      var workUrl;
      switch (item.codeType) {
        case 1:
          workUrl =
            "/scratch3/index.html?scene=additional&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName;
          break;
        case 2:
          workUrl =
            "/scratch3/index.html?scene=additional&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName;
          break;
        case 3:
          workUrl = "/scratchjr/editor.html?scene=additional&mode=edit";
          break;
        case 4:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=turtle&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName;
          break;
        case 5:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=python&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName;
          break;
        case 6:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=c&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName;
          break;
        case 7:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=cpp&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName;
          break;
        case 8:
          workUrl =
            "/onlinecode/index.html?scene=additional&lang=java&additionalId=" +
            item.additionalWorkId +
            "&departId=" +
            item.departId +
            "&workName=" +
            item.workName;
          break;
        default:
          // workUrl = item.workUrl_url
          this.$refs.submitModal.open({
            workName: item.workName,
            additionalId: item.additionalWorkId,
            departId: item.departId,
          });
          return;
      }

      if (!reset && item.mineWork_url) {
        workUrl += "&workUrl=" + item.mineWork_url;
      } else if(item.workUrl){
        workUrl += "&workUrl=" + item.workUrl_url;
      }
      return workUrl
    },
    //提交成功关闭编辑器
    closeEditor() {
      let that = this
      let content = "";
      if(this.saved){
        content = '提交成功'
        that.editorUrl = ""
        that.visible = false
        this.$emit('close', that.saved)
      }else{
        content = '请确定代码已保存'
      }
      this.$confirm({
        title: '提示',
        content: <h2>{content}</h2>,
        onOk() {
          that.editorUrl = ""
          that.visible = false
          that.$emit('close', that.saved)
        },
        onCancel() { },
      });
    },
  }

}
</script>

<style lang="less" scoped>
</style>